window.PlummeI18n.register('no', {
  'actionApproval.approve': 'Godkjenn',
  'actionApproval.approveAction': 'Godkjenn: {action}',
  'live.reviewTitle': 'Se over fakturaen',
  'live.reviewInvoice': 'Kontroller fakturaen nedenfor før du godkjenner.',
  'live.deliveryLabel': 'Send som',
  'live.approveSend': 'Godkjenn og send',
  'live.approveIssue': 'Godkjenn og opprett',
  'actionApproval.label.send_offer': 'Send tilbud',
  'actionApproval.label.send_credit_note': 'Send kreditnota',
  'actionApproval.label.send_reminder': 'Send betalingspåminnelse uten gebyr',
  'actionApproval.label.post_purchase': 'Registrer og bokfør kjøp',
  'actionApproval.label.reverse_purchase': 'Reverser kjøp',
  'actionApproval.label.post_manual_voucher': 'Bokfør bilag',
  'actionApproval.label.reverse_voucher': 'Reverser bilag',
  'actionApproval.label.approve_payroll_run': 'Godkjenn og bokfør lønnskjøring',
  'actionApproval.label.reverse_payroll_run': 'Reverser lønnskjøring',
  'actionApproval.label.record_payroll_submission': 'Bekreft at a-melding er sendt inn utenfor Plumme',
  'actionApproval.label.close_accounting_year': 'Godkjenn og lukk regnskapsåret',
  'actionApproval.label.reopen_accounting_year': 'Gjenåpne regnskapsåret',
  'actionApproval.label.delete_invoice_drafts': 'Slett fakturautkast',
  'actionApproval.label.delete_purchase_draft': 'Slett kjøpsutkast',
  'actionApproval.label.delete_payroll_draft': 'Slett lønnsutkast',
  'actionApproval.label.delete_project': 'Slett prosjekt',
  'actionApproval.label.invite_business_member': 'Inviter bruker til foretaket',
  'actionApproval.label.remove_business_member': 'Fjern brukerens tilgang til foretaket',
  'actionApproval.label.cancel_business_invite': 'Trekk tilbake invitasjon',
  'live.reading': 'Leser skjemaet og velger neste steg …',
  'live.open_editor': 'Åpner fakturaeditoren …', 'live.set_layout': 'Bytter visning …',
  'live.set_customer': 'Velger kunde …', 'live.set_field': 'Fyller inn felt …',
  'live.set_line': 'Fyller inn fakturalinje …', 'live.remove_line': 'Fjerner fakturalinje …',
  'live.open_customer_form': 'Klargjør ny kunde …', 'live.open_product_form': 'Klargjør nytt produkt …',
  'live.review': 'Åpner forhåndsvisning …', 'live.request_save': 'Klargjør for godkjenning …',
  'live.finish': 'Kontrollerer resultatet …', 'live.ask_user': 'Trenger en avklaring …',
  'live.approval': 'Venter på at du kontrollerer og lagrer skjemaet.',
  'live.customerApproval': 'Kontroller den nye kunden i skjemaet. Når du lagrer, fortsetter jeg på fakturaen.',
  'live.productApproval': 'Kontroller det nye produktet, prisen og MVA i skjemaet. Når du lagrer, fortsetter jeg på fakturaen.',
  'live.customerSaved': 'Kunden er lagret. Fortsetter med fakturaen.',
  'live.productSaved': 'Produktet er lagret. Fortsetter med fakturaen.',
  'live.cancelled': 'Opprettingen er avbrutt. Arbeidet på fakturaen er satt på pause.',
  'live.notApplied': 'Feltet ble ikke oppdatert som forventet. Jeg har stoppet, slik at du kan kontrollere skjemaet.',
  'live.limit': 'Jeg har nådd grensen for antall steg. Kontroller skjemaet og beskriv hva som gjenstår.',
  'live.done.open_editor': 'Fakturaeditoren er åpnet.', 'live.done.set_layout': 'Visningen er endret.',
  'live.done.set_customer': 'Kunden er valgt.', 'live.done.set_field': 'Feltet er fylt inn og kontrollert.',
  'live.done.set_line': 'Fakturalinjen er fylt inn og kontrollert.', 'live.done.remove_line': 'Fakturalinjen er fjernet.',
  'control.productRequired': 'Produktet finnes ikke i det aktive produktregisteret.',
});
window.PlummeI18n.register('en', {
  'actionApproval.approve': 'Approve',
  'actionApproval.approveAction': 'Approve: {action}',
  'live.reviewTitle': 'Review the invoice',
  'live.reviewInvoice': 'Check the invoice below before approving.',
  'live.deliveryLabel': 'Send as',
  'live.approveSend': 'Approve and send',
  'live.approveIssue': 'Approve and create',
  'live.reading': 'Reading the form and choosing the next step …',
  'live.open_editor': 'Opening the invoice editor …', 'live.set_layout': 'Changing the layout …',
  'live.set_customer': 'Selecting the customer …', 'live.set_field': 'Filling in a field …',
  'live.set_line': 'Filling in an invoice line …', 'live.remove_line': 'Removing an invoice line …',
  'live.open_customer_form': 'Preparing a new customer …', 'live.open_product_form': 'Preparing a new product …',
  'live.review': 'Opening the preview …', 'live.request_save': 'Preparing for approval …',
  'live.finish': 'Checking the result …', 'live.ask_user': 'Clarification needed …',
  'live.approval': 'Waiting for you to review and save the form.',
  'live.customerApproval': 'Review the new customer in the form. After you save, I will continue with the invoice.',
  'live.productApproval': 'Review the new product, price and VAT in the form. After you save, I will continue with the invoice.',
  'live.customerSaved': 'Customer saved. Continuing with the invoice.',
  'live.productSaved': 'Product saved. Continuing with the invoice.',
  'live.cancelled': 'Creation cancelled. Work on the invoice is paused.',
  'live.notApplied': 'The field did not update as expected. I stopped so you can check the form.',
  'live.limit': 'The step limit has been reached. Check the form and describe what remains.',
  'live.done.open_editor': 'Invoice editor opened.', 'live.done.set_layout': 'Layout changed.',
  'live.done.set_customer': 'Customer selected.', 'live.done.set_field': 'Field filled in and checked.',
  'live.done.set_line': 'Invoice line filled in and checked.', 'live.done.remove_line': 'Invoice line removed.',
  'control.productRequired': 'The product is not in the active product catalogue.',
});

window.PlummeI18n.register('no', {
  'control.intro': 'Fortell hvilken faktura du vil lage. Jeg fyller ut skjemaet og kan opprette n?dvendige kunder og produkter. Be uttrykkelig om ? opprette og sende n?r jeg skal fullf?re fakturaen.',
  'live.create_customer': 'Lagrer kunden ?', 'live.create_product': 'Lagrer produktet ?',
  'live.issue_invoice': 'Oppretter fakturaen ?', 'live.send_invoice': 'Oppretter og sender fakturaen ?',
  'live.finished': 'Utfyllingen er ferdig. Endringene er kontrollert i fakturaskjemaet.',
  'live.clarification': 'Beskriv hva du vil gj?re videre med fakturaen.',
  'live.invoiceIssued': 'Fakturaen er opprettet. Den er ikke sendt.',
  'live.invoiceSent': 'Fakturaen er sendt p? e-post.',
  'live.emailRequired': 'For ? sende trenger jeg kundens e-postadresse og avsenderens e-post i firmainnstillingene. Oppgi mottakeradressen sammen med en ny beskjed om ? sende.',
  'live.authorizationRequired': 'Skriv uttrykkelig hva du vil opprette eller sende.',
  'live.deliveryUncertain': 'Sending er allerede fors?kt. Kontroller sendingsstatus i fakturalisten f?r et nytt fors?k, slik at kunden ikke f?r fakturaen dobbelt.',
  'live.deliveryNotSent': 'Fakturaen er opprettet, men sending ble ikke bekreftet. Kontroller sendingsstatus i fakturalisten.',
  'live.ambiguousRecord': 'Flere kunder eller produkter har samme navn. Velg riktig oppf?ring f?rst.',
  'live.actionBusy': 'En lagring eller sending p?g?r allerede.',
});
window.PlummeI18n.register('en', {
  'control.intro': 'Describe the invoice you want. I fill in the form and can create required customers and products. Explicitly ask me to issue and send when you want to complete the invoice.',
  'live.create_customer': 'Saving customer ?', 'live.create_product': 'Saving product ?',
  'live.issue_invoice': 'Issuing invoice ?', 'live.send_invoice': 'Issuing and sending invoice ?',
  'live.finished': 'The requested fields are filled in and checked in the invoice editor.',
  'live.clarification': 'Describe what you want to do next with the invoice.',
  'live.invoiceIssued': 'Invoice issued. It has not been sent.',
  'live.invoiceSent': 'Invoice sent by email.',
  'live.emailRequired': 'Sending requires the customer email and the sender email in business settings. Provide the recipient address with a new request to send.',
  'live.authorizationRequired': 'Explicitly state what you want to create or send.',
  'live.deliveryUncertain': 'Delivery was already attempted. Check its status in the invoice list before trying again to avoid duplicate delivery.',
  'live.deliveryNotSent': 'Invoice issued, but delivery was not confirmed. Check the invoice list.',
  'live.ambiguousRecord': 'Several customers or products have the same name. Select the correct record first.',
  'live.actionBusy': 'A save or delivery is already in progress.',
});

window.PlummeI18n.register('no', {
  'appControl.changed': 'Siden eller virksomheten er endret. Kontroller siden og be meg fortsette.',
  'appControl.unsupported': 'Denne kontrollen krever at du bruker den direkte i siden.',
  'appControl.authorization': 'Fortell hvilken handling du vil at jeg skal utføre.',
  'appControl.manual': 'Fullfør dette steget direkte i siden, så kan jeg fortsette.',
  'appControl.option': 'Valget er ikke tilgjengelig i dette feltet.',
  'appControl.repeated': 'Handlingen er allerede forsøkt. Kontroller resultatet i siden før du fortsetter.',
});
window.PlummeI18n.register('en', {
  'appControl.changed': 'The page or business changed. Check the page and ask me to continue.',
  'appControl.unsupported': 'This control needs to be used directly on the page.',
  'appControl.authorization': 'Tell me which action you want me to perform.',
  'appControl.manual': 'Complete this step on the page, then I can continue.',
  'appControl.option': 'This option is not available in the field.',
  'appControl.repeated': 'This action was already attempted. Check its result on the page before continuing.',
});

window.PlummeI18n.register('no', {
  'actionApproval.title': 'Godkjenn handling', 'actionApproval.body': 'Kontroller handlingen og opplysningene nedenfor. Godkjenningen gjelder bare dette steget.',
  'actionApproval.confirm': 'Godkjenn og utfør', 'actionApproval.proposal': 'Foreslått handling', 'actionApproval.context': 'Opplysninger som handlingen gjelder',
  'actionApproval.cancel': 'Avbryt', 'actionApproval.mcp': 'Handling fra tilkoblet AI', 'actionApproval.failed': 'Handlingen kunne ikke utføres. Hent et nytt forslag og prøv igjen.',
  'actionApproval.loading': 'Henter handlingen ...', 'actionApproval.done': 'Handlingen er utført.', 'actionApproval.business': 'Virksomhet',
});
window.PlummeI18n.register('en', {
  'actionApproval.title': 'Approve action', 'actionApproval.body': 'Review the action and details below. Your approval applies only to this step.',
  'actionApproval.confirm': 'Approve and execute', 'actionApproval.proposal': 'Proposed action', 'actionApproval.context': 'Details affected by the action',
  'actionApproval.cancel': 'Cancel', 'actionApproval.mcp': 'Action from connected AI', 'actionApproval.failed': 'The action could not be completed. Request a new proposal and try again.',
  'actionApproval.loading': 'Loading action ...', 'actionApproval.done': 'The action is completed.', 'actionApproval.business': 'Business',
});

window.PlummeI18n.register('no', {'actionApproval.writeScope': 'AI-en kan foreslå skrivehandlinger. Hver handling må godkjennes av deg i Plumme før den utføres.'});
window.PlummeI18n.register('en', {'actionApproval.writeScope': 'The AI can propose write actions. You must approve each action in Plumme before it is executed.'});

window.PlummeI18n.register("no", {
  "actionApproval.label.create_invoice_draft": "Opprett fakturakladd",
  "actionApproval.label.register_invoice_payment": "Registrer fakturabetaling",
  "actionApproval.label.save_draft": "Lagre kladd",
  "actionApproval.label.send_invoice": "Send faktura",
  "actionApproval.label.issue_invoice": "Utsted faktura",
  "actionApproval.label.create_customer": "Opprett kunde",
  "actionApproval.label.create_product": "Opprett produkt",
  "actionApproval.label.invoice": "Faktura",
  "actionApproval.label.invoiceId": "Faktura-ID",
  "actionApproval.label.customer": "Kunde",
  "actionApproval.label.customerName": "Kundenavn",
  "actionApproval.label.currency": "Valuta",
  "actionApproval.label.amount": "Beløp",
  "actionApproval.label.date": "Dato",
  "actionApproval.label.dueDate": "Forfallsdato",
  "actionApproval.label.lines": "Linjer",
  "actionApproval.label.quantity": "Antall",
  "actionApproval.label.unitPrice": "Enhetspris",
  "actionApproval.label.vatRate": "MVA-sats",
  "actionApproval.label.description": "Beskrivelse",
  "actionApproval.label.business": "Virksomhet",
  "actionApproval.label.expires": "Gyldig til",
  "actionApproval.label.recipientEmail": "Mottaker",
  "actionApproval.label.fields": "Felt",
  "actionApproval.label.label": "Navn",
  "actionApproval.label.value": "Verdi",
  "actionApproval.label.text": "Opplysninger på siden",
  "actionApproval.label.action": "Handling",
  "actionApproval.label.click": "Trykk",
  "actionApproval.label.fill": "Fyll inn",
  "actionApproval.label.select": "Velg",
  "actionApproval.label.check": "Endre valg",
  "actionApproval.label.checked": "Valgt",
  "actionApproval.label.post": "Bokfør",
  "actionApproval.label.approve": "Godkjenn lønnskjøring",
  "actionApproval.label.close_year": "Godkjenn og lukk regnskapsåret",
  "actionApproval.label.reopen_year": "Gjenåpne regnskapsåret",
  "actionApproval.label.manage_members": "Endre tilganger",
  "actionApproval.label.delete": "Slett eller reverser",
  "actionApproval.label.submit": "Send inn",
  "actionApproval.label.expense": "Kjøp",
  "actionApproval.label.supplier": "Leverandør",
  "actionApproval.label.year": "År",
  "actionApproval.label.records": "Oppføringer"
});

window.PlummeI18n.register("en", {
  'actionApproval.label.send_offer': 'Send offer',
  'actionApproval.label.send_credit_note': 'Send credit note',
  'actionApproval.label.send_reminder': 'Send payment reminder without a fee',
  'actionApproval.label.post_purchase': 'Register and post purchase',
  'actionApproval.label.reverse_purchase': 'Reverse purchase',
  'actionApproval.label.post_manual_voucher': 'Post voucher',
  'actionApproval.label.reverse_voucher': 'Reverse voucher',
  'actionApproval.label.approve_payroll_run': 'Approve and post payroll run',
  'actionApproval.label.reverse_payroll_run': 'Reverse payroll run',
  'actionApproval.label.record_payroll_submission': 'Confirm payroll submission made outside Plumme',
  'actionApproval.label.close_accounting_year': 'Approve and close accounting year',
  'actionApproval.label.reopen_accounting_year': 'Reopen accounting year',
  'actionApproval.label.delete_invoice_drafts': 'Delete invoice drafts',
  'actionApproval.label.delete_purchase_draft': 'Delete purchase draft',
  'actionApproval.label.delete_payroll_draft': 'Delete payroll draft',
  'actionApproval.label.delete_project': 'Delete project',
  'actionApproval.label.invite_business_member': 'Invite business member',
  'actionApproval.label.remove_business_member': 'Remove business member access',
  'actionApproval.label.cancel_business_invite': 'Cancel business invitation',
  "actionApproval.label.create_invoice_draft": "Create invoice draft",
  "actionApproval.label.register_invoice_payment": "Register invoice payment",
  "actionApproval.label.save_draft": "Save draft",
  "actionApproval.label.send_invoice": "Send invoice",
  "actionApproval.label.issue_invoice": "Issue invoice",
  "actionApproval.label.create_customer": "Create customer",
  "actionApproval.label.create_product": "Create product",
  "actionApproval.label.invoice": "Invoice",
  "actionApproval.label.invoiceId": "Invoice ID",
  "actionApproval.label.customer": "Customer",
  "actionApproval.label.customerName": "Customer name",
  "actionApproval.label.currency": "Currency",
  "actionApproval.label.amount": "Amount",
  "actionApproval.label.date": "Date",
  "actionApproval.label.dueDate": "Due date",
  "actionApproval.label.lines": "Lines",
  "actionApproval.label.quantity": "Quantity",
  "actionApproval.label.unitPrice": "Unit price",
  "actionApproval.label.vatRate": "VAT rate",
  "actionApproval.label.description": "Description",
  "actionApproval.label.business": "Business",
  "actionApproval.label.expires": "Expires",
  "actionApproval.label.recipientEmail": "Recipient",
  "actionApproval.label.fields": "Fields",
  "actionApproval.label.label": "Name",
  "actionApproval.label.value": "Value",
  "actionApproval.label.text": "Page details",
  "actionApproval.label.action": "Action",
  "actionApproval.label.click": "Click",
  "actionApproval.label.fill": "Fill in",
  "actionApproval.label.select": "Select",
  "actionApproval.label.check": "Change selection",
  "actionApproval.label.checked": "Selected",
  "actionApproval.label.post": "Post to accounts",
  "actionApproval.label.approve": "Approve payroll run",
  "actionApproval.label.close_year": "Approve and close accounting year",
  "actionApproval.label.reopen_year": "Reopen accounting year",
  "actionApproval.label.manage_members": "Change access",
  "actionApproval.label.delete": "Delete or reverse",
  "actionApproval.label.submit": "Submit",
  "actionApproval.label.expense": "Purchase",
  "actionApproval.label.supplier": "Supplier",
  "actionApproval.label.year": "Year",
  "actionApproval.label.records": "Records"
});
